document.addEventListener("DOMContentLoaded", function() {

	let contact_trigger = document.getElementById('branch-contact-trigger');
	let contact_modal = document.getElementById('branch-contact');

	if(contact_trigger && contact_modal) {

		contact_trigger.addEventListener("submit", function(e) {
			e.preventDefault();

			let service = (e.target).querySelector('select[name="service"]');

			let name = (e.target).querySelector('input[name="name"]');
			let email = (e.target).querySelector('input[name="email"]');
			let cc = (e.target).querySelector('input[name="cc"]');
			let phone = (e.target).querySelector('input[name="phone"]');

			let service_label = document.getElementById('branch-contact-service-label');

			let branch_name = contact_modal.querySelector('input[name="branch_name"]');
			let branch_email = contact_modal.querySelector('input[name="branch_email"]');
            let branch_email_cc = contact_modal.querySelector('input[name="branch_email_cc"]');

			let branch_phone = contact_modal.querySelector('input[name="branch_phone"]');

			let branch_selected_service = contact_modal.querySelector('input[name="branch_chosen_service"]');
			
			let active_service = contact_modal.querySelector('input[value="' + service.value + '"]');

			if(service_label) {
				service_label.innerHTML = (service.value).replace('_', ' ');
			}

			if(branch_name) {
				branch_name.value = name.value;
			}

			if(branch_email) {
				branch_email.value = email.value;
			}

			if(branch_email_cc) {
				branch_email_cc.value = cc.value;
			}

			if(branch_phone) {
				branch_phone.value = phone.value;
			}

			if(active_service) {
				active_service.parentNode.parentNode.classList.add('selected-service');
			}

			if(branch_selected_service) {
				branch_selected_service.value = (service.value)[0].toUpperCase() + (service.value).slice(1);
			}

			contact_modal.classList.add('active');
		});

		document.addEventListener('click', function (event) {
	
			//if the clicked element is a open/close button
			if (event.target.matches('#close-contact')) {
				contact_modal.classList.remove('active');

				let active_service = document.getElementsByClassName('selected-service')[0];

				if(active_service) {
					active_service.classList.remove('selected-service');
				}
			}
		});
	}

}); 

// Init read smore npm library 

import ReadSmore from 'read-smore'

// target all read smore elements
const readMores = document.querySelectorAll('.js-read-smore')

// init
ReadSmore(readMores).init()